import { paymentType as PaymentType } from '@ourbranch/lookups';
import { isFarmInstallmentPlan } from '@ourbranch/farm-utils';

/**
 * Given and offer a policy type returns a formatted string with
 * the calculated monthly and total prices with all their variations
 * @param {object} offer
 * @param {string} policyType
 * @param {function} usePriceCalculator
 */
const usePlanPrice = (offer, policyType, usePriceCalculator) => {
  const isHomeMonthly = offer ? offer.quote.global.homeownersPaymentType === PaymentType.Monthly : undefined;
  // "Monthly" here means "paid in installments": CFM auto also sells 2 payments (#36200), like farm.
  const isAutoMonthly = offer
    ? [PaymentType.Monthly, PaymentType.HalfTerm].includes(offer.quote.global.autoPaymentType)
    : undefined;
  const isRentersMonthly = offer ? offer.quote.global.rentersPaymentType === PaymentType.Monthly : undefined;
  const isCondoMonthly = offer ? offer.quote.global.condoPaymentType === PaymentType.Monthly : undefined;
  // Shared with the farm Quote/Application Payment Plan section (#36434).
  const isFarmMonthly = offer ? isFarmInstallmentPlan(offer.quote.global.farmPaymentType) : undefined;

  const priceData = usePriceCalculator(offer, policyType);

  return { isHomeMonthly, isAutoMonthly, isRentersMonthly, isCondoMonthly, isFarmMonthly, ...priceData };
};

export default usePlanPrice;
